/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventCategoryCountResponse
 */
export interface AuditEventCategoryCountResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditEventCategoryCountResponse
     */
    category?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventCategoryCountResponse
     */
    count?: any | null;
}

/**
 * Check if a given object implements the AuditEventCategoryCountResponse interface.
 */
export function instanceOfAuditEventCategoryCountResponse(value: object): value is AuditEventCategoryCountResponse {
    return true;
}

export function AuditEventCategoryCountResponseFromJSON(json: any): AuditEventCategoryCountResponse {
    return AuditEventCategoryCountResponseFromJSONTyped(json, false);
}

export function AuditEventCategoryCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventCategoryCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] === undefined ? undefined : json['category'] === null ? null : json['category'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
    };
}

export function AuditEventCategoryCountResponseToJSON(json: any): AuditEventCategoryCountResponse {
    return AuditEventCategoryCountResponseToJSONTyped(json, false);
}

export function AuditEventCategoryCountResponseToJSONTyped(value?: AuditEventCategoryCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'count': value['count'],
    };
}

